import { shallowRef } from 'vue'

import TheBorderStyle from "@/components/styles/TheBorderStyle.vue";
import TheTextStyle from "@/components/styles/TheTextStyle.vue";
import TheFontStyle from "@/components/styles/TheFontStyle.vue";

const theBorderStyle = shallowRef(TheBorderStyle)
const theTextStyle = shallowRef(TheTextStyle)
const theFontStyle = shallowRef(TheFontStyle)

export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			styles: [
				{
					component: theBorderStyle,
					category: 'border',
					types: [
						{
							visible: true,
							multiSelect: true,
							type: null,
							options: [
								{icon: 'border_top', name: 'border-top', value: "black"},
								{icon: 'border_bottom', name: 'border-bottom', value: 'black'},
								{icon: 'border_left', name: 'border-left', value: 'black'},
								{icon: 'border_right', name: 'border-right', value: 'black'},
							],
						},
						{
							visible: true,
							multiSelect: false,
							type: null,
							options: [
								{icon: 'horizontal_rule', name: '-style', value: 'solid'},
								{icon: 'drag_handle', name: '-style', value: 'double'},
							],
						},
						{
							visible: false,
							multiSelect: false,
							type: null,
							options: [
								{icon: 'horizontal_rule', name: '-width', value: '1.5px'},
								{icon: 'drag_handle', name: '-width', value: '4px'},
							],
						},
					],
					selectedOptions:[
						{options: null as any}, {options: null as any}, {options: null as any}
					],
				},
				{
					component: theTextStyle,
					category: 'text',
					types: [
						{
							visible: true,
							multiSelect: false,
							type: null,
							options: [
								{icon: 'format_align_left', name: 'text-align', value: 'left'},
								{icon: 'format_align_center', name: 'text-align', value: 'center'},
								{icon: 'format_align_right', name: 'text-align', value: 'right'},
							],
						},
						{
							visible: true,
							multiSelect: false,
							type: 'color',
							options: [
								{icon: 'format_color_text', name: 'color', value: 'black'},
							],
						},
					],
					selectedOptions:[
						{options: null as any}, {options: null as any}
					],
				},
				{
					component: theFontStyle,
					category: 'font',
					types: [
						{
							visible: true,
							multiSelect: false,
							type: null,
							options: [
								{icon: 'format_bold', name: 'font-weight', value: 'bold'},
							],
						},
						{
							visible: true,
							multiSelect: false,
							type: null,
							options: [
								{icon: 'format_italic', name: 'font-style', value: 'italic'},
							],
						},
						{
							visible: true,
							multiSelect: false,
							type: null,
							options: [
								{icon: 'format_underlined', name: 'text-decoration', value: 'underline'},
							],
						},
					],
					selectedOptions:[
						{options: null as any}, {options: null as any}, {options: null as any}
					],
				},
			],
			
		}
	},
	computed: {
		//
	},
};